export const AUTH_SCREEN_STORAGE_KEY = 'varcardio:show-auth-screen';

export function shouldKeepAuthScreenVisible(params: {
  hasUser: boolean;
  storedAuthIntent: boolean;
  redirectError: boolean;
}) {
  if (params.hasUser) return false;
  return params.storedAuthIntent || params.redirectError;
}

export function normalizeAuthErrorMessage(error: unknown) {
  const code = typeof error === 'object' && error && 'code' in error ? String((error as { code?: unknown }).code) : '';
  switch (code) {
    case 'auth/invalid-email':
      return 'Enter a valid email address.';
    case 'auth/missing-password':
      return 'Enter your password.';
    case 'auth/weak-password':
      return 'Password must be at least 6 characters.';
    case 'auth/email-already-in-use':
      return 'That email is already registered. Try signing in instead.';
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Invalid email or password.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';
    case 'auth/operation-not-allowed':
      return 'Email/password auth is not enabled in Firebase yet.';
    default:
      return error instanceof Error ? error.message : 'Authentication failed.';
  }
}
